import React from 'react'
import ImageComponent from './image'
const SectionCallComponent = props =>
    <div className="section--secondary" id="call">
        <div className="section__grid">
            <div className="section__text">
                <h2><strong>Extended Call for Abstracts!</strong></h2>
                <p>If you are considering submitting a proposal related to zooarchaeology, now is the time.<br />
                    We accept proposals for papers and posters on any topic related to zooarchaeology.</p>
                    <p><strong>The program will be announced once the abstracts have been selected</strong></p>
                    <p>The <strong>deadline</strong> for sending an abstract is extended until the <strong>15<sup>st</sup> April 2018</strong></p>
            </div>
            <div className="section__text u-text-center">
                <p className="c-grid--thirds">
                    <ImageComponent image="txt" />
                    <ImageComponent image="pdf" />
                    <ImageComponent image="word" />
                </p>
                <p>
                    <a className="c-btn--secondary-alt" href="https://goo.gl/forms/OQOVBuOh1XWDXeuq2" target="_blank">Send your abstract</a>
                </p>
            </div>
        </div>
    </div>

export default SectionCallComponent



// WEBPACK FOOTER //
// ./src/components/section-call.js